/* src/app/shared/components/mce-editor/equation-editor-dialog.component.scss */
.eq-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #616161;
  margin-bottom: 4px;
  margin-top: 12px;
}
.eq-label:first-child {
  margin-top: 0;
}
.eq-input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  font-family: "Courier New", monospace;
  font-size: 14px;
  resize: vertical;
}
.eq-input:focus {
  outline: none;
  border-color: #1565c0;
}
.eq-preview {
  min-height: 60px;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fafafa;
  text-align: center;
  overflow-x: auto;
}
.eq-placeholder {
  color: #9e9e9e;
  font-size: 13px;
  font-style: italic;
}
.eq-error {
  color: #c62828;
  font-size: 13px;
}
.eq-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #757575;
}
.eq-hint code {
  background: #f5f5f5;
  padding: 1px 4px;
  border-radius: 3px;
  font-family: "Courier New", monospace;
}
/*# sourceMappingURL=equation-editor-dialog.component-AZCSHR7K.css.map */
